const items = [
  "EXPLORE ANIMALS",
  "MASTER SPACE",
  "SOLVE RIDDLES",
  "EARN STARS",
  "LEARNING IS PLAY",
  "ZERO ADS",
  "KID-SAFE FUN",
];

export const Marquee = ({ dark = false }) => {
  const row = [...items, ...items];
  return (
    <div
      data-testid="marquee-strip"
      className={`overflow-hidden border-y-2 border-ink py-3.5 select-none ${
        dark ? "bg-ink text-cream" : "bg-sun text-ink"
      }`}
    >
      <div className="flex w-max animate-marquee gap-0">
        {row.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-6 pr-6 font-display font-extrabold text-sm sm:text-base tracking-[0.15em] whitespace-nowrap"
          >
            {item}
            <span className={dark ? "text-sun" : "text-coral"}>✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
